import { useMemo } from 'react';
import useTrackerProps from './useTrackerProps';
import env from 'enviro';
import events from '../../events.yaml';
const useLibTracker = () => {
  const {
    tableTrackerProps: {
      tracker
    }
  } = useTrackerProps();
  return useMemo(() => {
    if (!tracker) {
      if (env.isQa()) {
        console.error("[content-management-listing-lib] tracker was not set by host application and we won't be able to track events.");
      }
      return undefined;
    }
    return tracker.clone({
      events,
      preserveTrackerProperties: false,
      standalone: false
    });
  }, [tracker]);
};
export default useLibTracker;